import { assertSome, Maybe } from '@crocodille/util';
import React, { createContext, useContext } from 'react';
import { SWRConfig, SWRConfiguration } from 'swr';

import { App } from './app';

const AppContext = createContext<Maybe<App>>(null);

const SWR_CONFIG = {
  revalidateOnFocus: false,
  revalidateOnReconnect: false,
} satisfies SWRConfiguration;

export function AppProvider({
  app,
  children,
}: React.PropsWithChildren<{
  readonly app: App;
}>) {
  return (
    <SWRConfig value={SWR_CONFIG}>
      <AppContext.Provider value={app}>{children}</AppContext.Provider>
    </SWRConfig>
  );
}

export function useApp() {
  const app = useContext(AppContext);

  return assertSome(app, 'Must be used within AppProvider');
}
